import Vue from 'vue'

export default {
  state: {
    language: 'uk'
  },
  getters: {
    translations: () => (key) => {
      return Vue.i18n.translate(key)
    },
    urlLanguagePrefix: state => {
      if (state.language === 'ru') {
        return '/' + state.language
      } else {
        return ''
      }
    },
    isUkLanguage: state => {
      return state.language === 'uk'
    }
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language
    }
  }
}
